const KeyCodes = {
    ENTER: 13,
    ESCAPE: 27
};

export default KeyCodes;
